import './home.scss';
import * as busyCounter from '../../shared/action-creator/busy-counter';
import { Link, withRouter } from 'react-router-dom';
import React, { Component } from 'react';
import { createErrorMessage, createSuccessMessage } from '../../shared/action-creator/alert-messages';
import BusyCounterLoadingIndicator from '../../shared/components/busyCounter/busy-counter-loading-indicator';
import PropTypes from 'prop-types';
import { ReportUrlMap } from '../report-url-map';
import { connect } from 'react-redux';
import { getReports } from '../repositories';
import { isEqual } from 'lodash';
import { setReports } from '../../shared/action-creator/reports';
import { showLoadingIndicator } from '../../shared/state/busy-counter';

const left = [
    'Order Information',
    'Reports'
];
const right = [
    'Constraints',
    'Parameters',
    'Pools',
    'Linked Orders',
    'Other'
];

class Home extends Component {

    state = {
        // privileges: {},
        // reports: []
    };

    componentDidMount = () => {
        this.loadReports();
    }

    componentDidUpdate(prevProps) {
        const { unit, reports } = this.props;

        // Check if unit or reports have changed
        if (unit.name !== prevProps.unit.name || !isEqual(reports, prevProps.reports)) {
            this.loadReports();
        }
    }

    loadReports = () => {
        const { unit, reports } = this.props;
        const lsUnit = localStorage.getItem('selectedUnit');
        const units = lsUnit ? JSON.parse(lsUnit) : {};
        const report = reports && reports[units.name];

        if (!report || report.unitName !== units.name) {
            this.props.increaseCounter();
            getReports().then(response => {
                if (!isEqual(response, this.props.reports[this.props.unit.name])) {
                    this.props.setReports(this.props.unit.name, response);
                }
                this.props.decreaseCounter();
            }).catch(() => {
                this.props.decreaseCounter();
            });
        }
    }

    fetchUrl = report => {
        const url = ReportUrlMap[report];
        if (url) return url;
        return '/in-progress';
    };

    getSection = (name, headers) => headers.filter(item => item.name === name);

    section = (item, unitPrefix) => {
        const { reports, unit } = this.props;
        const dbType = reports && reports[unit.name] ? reports[unit.name].dbType : null;
        const atpTransactionURL = reports && reports[unit.name] ? reports[unit.name].atpTransactionURL : null;
        
        
        if (item.name === 'Other') {
            return (
                <React.Fragment key={item.name}>
                    <h5>{item.name}</h5>
                    {item.children.map(child => (
                        dbType === 'POSTGRESQL' && child.name === 'ATP Transaction' ? (
                            <h6 key={`${child.name}-dbType`}>
                                <a href={atpTransactionURL} target="_blank" rel="noopener noreferrer">
                                    {child.name}
                                </a>
                            </h6>
                        ) : (
                            <h6 key={child.name}>
                                {this.fetchUrl(child.name) !== '/in-progress' && (
                                    <Link to={`${unitPrefix}${this.fetchUrl(child.name)}`}>
                                        {child.name}
                                    </Link>
                                )}
                            </h6>
                        )
                    ))}
                </React.Fragment>
            );
        }

        return (
            <React.Fragment key={item.name}>
                <h5>{item.name}</h5>
                {item.children.map(child => (
                    <h6 key={child.name}>
                        {this.fetchUrl(child.name) !== '/in-progress' && (
                            <Link to={`${unitPrefix}${this.fetchUrl(child.name)}`}>
                                {child.name}
                            </Link>
                        )}
                    </h6>
                ))}
            </React.Fragment>
        );
    };

    render() {
        const { name } = this.props.unit;
        const unitPrefix = `/${name}`;
        const { reports } = this.props;
        const headers = reports && reports[name] ? reports[name].headers : [];
        return (
            <section className="home-placeholder">
                <BusyCounterLoadingIndicator busyCounter={this.props.busyCounter} />
                <main>
                    <div className="home-section">
                        {headers && headers.length > 0 && (
                            left.map(i =>
                                this.getSection(i, headers).map(item =>
                                    this.section(item, unitPrefix)
                                )
                            )
                        )}
                    </div>
                    <div className="home-section">
                        {headers && headers.length > 0 && (
                            right.map(i =>
                                this.getSection(i, headers).map(item =>
                                    this.section(item, unitPrefix)
                                )
                            )
                        )}
                    </div>
                </main>
            </section>
        );
    }
}

Home.displayName = 'Home';
Home.propTypes = {
    busyCounter: PropTypes.bool.isRequired,
    increaseCounter: PropTypes.func.isRequired,
    decreaseCounter: PropTypes.func.isRequired,
    reports: PropTypes.object,
    unit: PropTypes.object,
    location: PropTypes.object,
    match: PropTypes.object,
    history: PropTypes.object,
    createErrorMessage: PropTypes.func.isRequired,
    setReports: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
    busyCounter: showLoadingIndicator(state.application.busyCounter),
    reports: state.application.reports,
    unit: state.application.unit
});

const mapDispatchToProps = dispatch => ({
    increaseCounter: () => dispatch(busyCounter.increaseBusyCounter()),
    decreaseCounter: () => dispatch(busyCounter.decreaseBusyCounter()),
    createSuccessMessage: message => dispatch(createSuccessMessage(message)),
    createErrorMessage: message => dispatch(createErrorMessage(message)),
    setReports: (unit, reports) => dispatch(setReports(unit, reports))
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Home));
